let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bZN2I")).then(() => parcelRequire('4x7kJ'));